export const GET_PLANS_ATTEMPT = 'GET_PLANS_ATTEMPT';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_PLANS_SELECTED_PLAN = 'SET_PLANS_SELECTED_PLAN';
export const SET_PLANS_CURRENT_PLAN = 'SET_PLANS_CURRENT_PLAN';
export const SET_CURRENT_SELECTED_PLANS = 'SET_CURRENT_SELECTED_PLANS';
